import { useState } from 'react';
import { CATEGORY_LABELS } from '../lib/watch-format.js';
import { useUnsavedChanges } from '../lib/use-unsaved-changes.js';

export const PREFERENCE_VALUE_LABEL = Object.freeze({ immediate: 'Immediately', digest: 'Daily digest', off: 'Off' });

/**
 * One select per category with only the values the portal allows for this
 * person (spec 7.4: guardians never off; integrity is always immediate and is
 * not listed). The categories come from the portal, per person; nothing is
 * added here. Sends only the categories that changed.
 */
export default function WatchPreferencesForm({ model, categories, onSave, saving = false }) {
  const entries = Object.entries(model ?? {}).filter(([, values]) => Array.isArray(values) && values.length > 0);
  // The draft and the baseline start from the same effective value: a stored
  // value that is no longer allowed shows (and counts) as the first allowed one.
  const effective = (c, values) => (categories?.[c] && values.includes(categories[c]) ? categories[c] : values[0]);
  const [draft, setDraft] = useState(() => Object.fromEntries(entries.map(([c, values]) => [c, effective(c, values)])));
  const changed = Object.fromEntries(entries.filter(([c, values]) => draft[c] !== effective(c, values)).map(([c]) => [c, draft[c]]));
  const hasChange = Object.keys(changed).length > 0;
  useUnsavedChanges(hasChange);
  return (
    <form className="space-y-3" onSubmit={(e) => { e.preventDefault(); if (hasChange && !saving) onSave(changed); }}>
      {entries.map(([category, values]) => (
        <label key={category} className="block text-sm">
          <span className="label">{CATEGORY_LABELS[category] ?? category}</span>
          <select aria-label={CATEGORY_LABELS[category] ?? category} className="input sm:w-64" value={draft[category]} onChange={(e) => setDraft((d) => ({ ...d, [category]: e.target.value }))}>
            {values.map((v) => <option key={v} value={v}>{PREFERENCE_VALUE_LABEL[v] ?? v}</option>)}
          </select>
        </label>
      ))}
      <button type="submit" className="btn-primary" disabled={saving || !hasChange}>Save preferences</button>
    </form>
  );
}
